import { Injector, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { isEmpty, isUndefined, filter } from 'lodash';
import * as bowser from 'bowser';
import { LayoutService } from '../../../Services/layout/layout.service';
import { BaseComponent } from '../../base.component';
import { ChatbotService } from 'src/app/Services/chatbot-service/chatbot.service';

@Component({
	selector: 'app-popup',
	encapsulation: ViewEncapsulation.None,
	template: `
		<button
			class="popup-content popup-opener"
			*ngIf="
				(!isMobile || (icon !== 'phone' && icon !== 'message')) && (!shouldShowCallMeNow || name === 'Popup.TalkWithUs')
			"
			[attr.name]="title"
			[ngClass]="{
				open: isOpen
			}"
			[class]="customClass"
			(click)="togglePopup()"
			[attr.aria-label]="title"
		>
			<i class="icon" [ngClass]="iconClass"></i>
			<span
				class="title"
				[ngClass]="{
					'popup-title-consumer': getFlowType(),
					talkWithUs: name === 'Popup.TalkWithUs'
				}"
				[innerHtml]="title"
			></span>
			<span
				class="title short"
				[ngClass]="{
					'popup-title-consumer': getFlowType(),
					talkWithUs: name === 'Popup.TalkWithUs',
					saveForLater: name === 'Popup.SaveForLater'
				}"
				>{{ shortTitle }}</span
			>
		</button>
		<a
			class="popup-content popup-opener"
			*ngIf="isMobile && icon === 'phone'"
			[ngClass]="{
				open: isOpen
			}"
			[class]="customClass"
			[attr.name]="shortTitle"
			(click)="togglePopup()"
			role="button"
			[attr.aria-label]="title"
			><!--
    --><i class="icon" [ngClass]="iconClass"></i>
			<span
				class="title"
				[ngClass]="{
					'popup-title-consumer': getFlowType(),
					talkWithUs: name === 'Popup.TalkWithUs'
				}"
				[innerHtml]="title"
			></span
			><!--
    --><span
				class="title short"
				[ngClass]="{
					'popup-title-consumer': getFlowType(),
					talkWithUs: name === 'Popup.TalkWithUs'
				}"
				>{{ shortTitle }}</span
			>
		</a>
		<div
			class="popup-content-wrapper"
			[ngClass]="{
				'popup-content-wrapper-call-me-now-bottom': name === 'Popup.TalkWithUsBottom',
				'popup-content-wrapper-call-me-now-brick': name === 'Popup.TalkWithUsBrick',
				top: position === 'top'
			}"
		>
			<toggle-visible
				*ngIf="isOpen && popup.controls"
				[isOpen]="isOpen"
				(focusLost)="closeonblur($event)"
				(closeOnClick)="closeonblur($event)"
			>
				<div
					class="popup-content"
					[ngClass]="{
						saveForLater: popup.name === 'Popup.SaveForLater'
					}"
					role="dialog"
				>
					<!--
        --><button
						class="icon icon-arrow-left"
						title="back"
						*ngIf="
							popup.backButton &&
							popup.backButton.ajaxInfo &&
							popup.name !== 'Popup.TalkWithUsBottom' &&
							popup.name !== 'Popup.TalkWithUsBrick'
						"
						(click)="backButton()"
						gtm-handler
						events="click"
						handlerType="button"
						[label]="backButtonLabel"
						action="ButtonClick"
					></button
					><!--

          --><button class="icon icon-close" title="close" (click)="close()" tabindex="0"></button
					><!--

          --><control context="popup" [control]="control" *ngFor="let control of popup.controls"> </control
					><!--

          -->
					<div *ngIf="getFirstError()" class="error-container-popup">
						<div class="error">
							<i class="error-icon"></i>
							{{ getFirstError() }}
						</div>
					</div>
				</div>
			</toggle-visible>
		</div>
	`,
	styleUrls: ['./popup.component.scss'],
})
export class PopupCompoentnt extends BaseComponent implements OnInit {
	popup: popupData;
	@Input() icon: string;
	@Input() title: string;
	@Input() shortTitle: string;
	@Input() href: string;
	@Input() name: string;
	@Input() ajaxInfo: ajaxInfo;
	@Input() gaEventLabel: string;
	@Input() customClass: string;
	@Input() position: string;
	isOpen: boolean;
	flowtype: string;
	isMobile: boolean;
	popupCloseonblur: boolean;
	iconClass: string;
	backButtonLabel: string;
	gaLabel: string;
	shouldShowCallMeNow: boolean = false;

	constructor(injector: Injector, private LayoutService: LayoutService, private chatbotService: ChatbotService) {
		super(injector);
	}

	async ngOnInit() {
		this.gaLabel = this.gaEventLabel || this.name;
		this.isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
		this.isOpen = false;
		this.flowtype = '';
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data) {
				if (data && data.data && data.data.globalAttributes) {
					this.shouldShowCallMeNow = !!data.data.globalAttributes.shouldShowCallMeNow;
				}
				this.popup = data.data.ui.popup;
				if (!isEmpty(this.popup)) {
					(this.popup as any).controls = filter(this.popup.controls, (p) => {
						return p.visible;
					});
					this.isOpen = this.storeService.getState().data.ui.popup.name === this.name;
					this.popupCloseonblur = this.popup.closeonblur;
					if (this.isOpen) {
						let elemToSelect =
							this.name === 'Popup.TalkWithUsBottom'
								? '.popup-content-wrapper-call-me-now-bottom'
								: this.name === 'Popup.TalkWithUsBrick'
								? '.popup-content-wrapper-call-me-now-brick'
								: '.popup-content';
						if (this.elementRef.nativeElement.querySelector(elemToSelect)) {
							this.elementRef.nativeElement.querySelector(elemToSelect).focus(); // not good because it refer to all popups
						}
					}
				}
			}
		});
		if (this.name === 'Popup.TalkWithUs') {
			setTimeout(() => {
				const popContent = this.elementRef.nativeElement.querySelector('.popup-content');
				if (popContent) {
					this.Renderer.setAttribute(popContent, 'gtm', 'Talk with Us');
				}
			}, 0);
		}

		// For mock this can be used
		// this.flowtype = "";
		// const addonParams = this.storeService.getAddOnParams();
		// if (addonParams)
		// {
		//    this.flowtype = addonParams.dataLayerParams['channelType'];
		// }
		const Quoteflowtype =
			this.storeService.getAddOnParams() && this.storeService.getAddOnParams().dataLayerParams.channelType
				? this.storeService.getAddOnParams().dataLayerParams.channelType
				: null;
		if (Quoteflowtype === 'Direct') {
			this.flowtype = 'Direct';
		} else {
			this.flowtype = Quoteflowtype;
		}

		this.iconClass = this.getIconClass();
		this.backButtonLabel = this.getLabel();
	}

	togglePopup() {
		if (this.isOpen) {
			this.close();
		} else {
			if (this.name === 'Popup.TalkWithUs' || this.name === 'Popup.GetHelpInChat') {
				this.chatbotService.showDialog(false);
			}
			const emailData = this.LayoutService.staticLayout.getValue().data.answers['page']['PolicyData.Email'];
			if (
				this.name.split('.')[1] === 'SaveForLater' &&
				(emailData === null || emailData === undefined || emailData === '')
			) {
				delete this.layoutService.staticLayout.getValue().data.answers['page']['PolicyData.Email'];
			}
			this.actionService.ajaxAction(this.ajaxInfo, 'page');
		}
	}

	close() {
		this.storeService.closePopup();
		this.isOpen = false;
		this.elementRef.nativeElement.querySelector('button').blur();
		var name = this.name.split('.')[1];
		if (name === 'SaveForLater' || name === 'TalkWithUs') {
		}
	}

	getIconClass() {
		return `icon-${this.icon}`;
	}

	getFlowType() {
		return this.flowtype === 'Direct' ? true : false;
	}

	closeonblur(event) {
		if (this.popupCloseonblur !== undefined && !this.popupCloseonblur) {
			return;
		} else {
			this.isOpen = false;
		}
	}
	backButton() {
		const { ajaxInfo, name } = this.popup.backButton;
		return this.actionService.ajaxAction(ajaxInfo, 'popup');
	}

	getFirstError() {
		const controlName = Object.keys(this.storeService.getState().data.errors.popup)[0];

		if (!controlName) {
			return;
		}

		return this.storeService.getState().data.errors.popup[controlName][0];
	}

	getLabel() {
		return !isUndefined(this.popup.title) ? this.popup.title + '_Back' : '';
	}
}
